    export function formatTime (timestamp) {
        var d = new Date(timestamp)
        var y = d.getFullYear()
        var m = d.getMonth() + 1
        var date = d.getDate()
        var h = d.getHours()
        var min = d.getMinutes()
        var zero = val => val < 0 ? '0' + val : val

        m = zero(m)
        date = zero(date)
        h = zero(h)
        min = zero(min)

        return y + '-' + m + '-' + date
    }


// WEBPACK FOOTER //
// ./src/utils/index.js